import { useEffect } from "react";
import "./liveSessionFlow.css";

export const LIVE_SESSION_FLOW_CLASS = "live-session-flow";

/**
 * Scopes live-session scrollbar CSS to this route (including portaled UI).
 * Adds the class on document.body while the live session page is mounted.
 */
export function useLiveSessionFlowClass() {
  useEffect(() => {
    document.body.classList.add(LIVE_SESSION_FLOW_CLASS);
    return () => {
      document.body.classList.remove(LIVE_SESSION_FLOW_CLASS);
    };
  }, []);
}
